import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Filters, FilteringItem } from '@3ddv/ngx-sites-builder-lib';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { SblibService } from '../../services/sblib.service';
import { FiltersService } from './services/filters.service';
import { ToastrService } from 'ngx-toastr';
import { SidebarService } from '../../sb-editor-sidebar/services/sidebar.service';
import { Sidebar } from '../../sb-editor-sidebar/models/sidebar.model';
import { FilterGenerationComponent } from './filter-generation/filter-generation.component';

@Component({
  selector: 'app-sbeditor-tool-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription> = [];
  public tool: Filters;
  public itemList: Array<FilteringItem>;
  @ViewChild('filtergeneration', { static: false }) filtergenerationComponent: FilterGenerationComponent;

  // Toggle Custom / Default filters:
  // Custom: 1 color : 1 filtro : los colores se aplican por defecto al mapa, al filtrar se apagan los demás.
  // Default: Dorado para VIP (solo en el menu e filtros), Blanco para los demas: Se activa el color blanco al filtrar los demás se apagan.

  public tabs = { active: 'filtergeneration' };
  public sidebar: Sidebar = null;
  constructor(
    private toolsService: ToolsService,
    private filtersService: FiltersService,
    private sblibService: SblibService,
    private sidebarService: SidebarService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.filters) {
        this.tool = JSON.parse(JSON.stringify(res.filters));
        this.itemList = this.tool.data;
      } else {
        console.error('filters tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);

    const sidebarasync$ = this.sidebarService.getAsyncSidebar$().subscribe(res => {
      this.sidebar = res;
    });
    this.subscriptions.push(sidebarasync$);

    const sidebar$ = this.sidebarService.getSidebar$().subscribe(res => {
      this.sidebar = res;
    });
    this.subscriptions.push(sidebar$);

    const listAndHash$ = this.filtersService.getListAndHash$().subscribe(res => {
      this.itemList = res.data;
    });
    this.subscriptions.push(listAndHash$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public save() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      res.filters.enabled = this.tool.enabled;
      res.filters.multipleFilters = this.tool.multipleFilters;
      res.filters.data = JSON.parse(JSON.stringify(this.itemList));
      res.filters.hashed = JSON.parse(JSON.stringify(this.filtersService.parseListToHash(this.itemList, {})));
      res.filters.integration.template = JSON.parse(JSON.stringify(this.tool.integration.template));
      res.filters.data = this.filtersService.recursiveRemoveFromListKey('manage', res.filters.data);
      res.filters.hashed = this.filtersService.removeKeyFromObj('manage', res.filters.hashed);
      res.filters.integration.defaultmode = JSON.parse(JSON.stringify(this.tool.integration.defaultmode));
      this.tool = Object.assign({}, res.filters);
      this.sblibService.apply(res);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(tools$);
  }

  public finishedUpload($event) {
    console.log($event);
  }
}
